export default {
      id: "clear-usage",
      viewBox: "0 0 24 24",
      url: "/assets/svg/" + "sprite.svg#clear-usage",
      toString: function () {
        return this.url;
      }
    }